import { render } from "./SimpleSelect.vue?vue&type=template&id=be86795e"
import script from "./SimpleSelect.vue?vue&type=script&lang=js"
export * from "./SimpleSelect.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/selects/SimpleSelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "be86795e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('be86795e', __exports__)) {
    console.log('reload')
    api.reload('be86795e', __exports__)
  }
  
  module.hot.accept("./SimpleSelect.vue?vue&type=template&id=be86795e", () => {
    console.log('re-render')
    api.rerender('be86795e', render)
  })

}


export default __exports__